export default {
  description: 'Você ainda não foi redirecionado para a sua página?',
  cta: 'Clique aqui para continuar',
};
